import React, { useState } from 'react';
import { Modal, Spinner } from 'react-bootstrap';

const ServicosTab = ({
  servicos,
  showModal,
  handleCloseModal,
  handleOpenModal,
  handleEditClick,
  handleToggleStatus,
  isLoading,
  formData,
  handleChange,
  handleSubmit,
  tiposMateriais,
  isLoadingMaterialData,
  materiais,
  selectedMaterialsData,
  handleMaterialChange,
  handleQuantidadeChange,
  custoMaterialCalculado,
  currentServico,
  mostrarInativos,
  setMostrarInativos,
  especialidades,
  handleSelectAllEspecialidades,
}) => {
  const [activeModalTab, setActiveModalTab] = useState('dadosBasicos');
  const todasEspecialidadesSelecionadas = (especialidades || []).length > 0
    && (especialidades || []).every(especialidade =>
      (formData.especialidades || []).map(Number).includes(Number(especialidade.id))
    );

  // Reset aba ao abrir modal
  React.useEffect(() => {
    if (showModal) setActiveModalTab('dadosBasicos');
  }, [showModal]);

  const fieldStyle = {
    width: '100%', padding: '9px 12px', borderRadius: '8px',
    border: '1px solid #e5e7eb', fontSize: `calc(13px * var(--font-scale))`, color: '#374151',
    fontFamily: "'Inter', 'Segoe UI', sans-serif", outline: 'none',
    backgroundColor: '#fff', transition: 'border-color 0.15s, box-shadow 0.15s',
  };

  const labelStyle = {
    fontSize: `calc(11px * var(--font-scale))`, fontWeight: '700', color: '#6b7280',
    textTransform: 'uppercase', letterSpacing: '0.5px',
    display: 'block', marginBottom: '5px',
    fontFamily: "'Inter', 'Segoe UI', sans-serif",
  };

  const handleFieldFocus = (e) => {
    e.target.style.borderColor = '#3b82f6';
    e.target.style.boxShadow = '0 0 0 3px rgba(59,130,246,0.1)';
  };
  const handleFieldBlur = (e) => {
    e.target.style.borderColor = '#e5e7eb';
    e.target.style.boxShadow = 'none';
  };

  // Materiais filtrados pelo tipo selecionado
  const materiaisFiltrados = materiais.filter(
    m => formData.tipos_materiais.includes(m.materiais_tipos_id)
  );

  return (
    <div style={{ fontFamily: "'Inter', 'Segoe UI', sans-serif" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

        .servicos-table { width: 100%; border-collapse: collapse; }
        .servicos-table thead tr {
          background: linear-gradient(135deg, #f8fafc, #f1f5f9);
          border-bottom: 2px solid #e2e8f0;
        }
        .servicos-table thead th {
          padding: 12px 16px; font-size: 11px; font-weight: 700;
          color: #64748b; text-transform: uppercase; letter-spacing: 0.5px;
          white-space: nowrap; font-family: 'Inter', 'Segoe UI', sans-serif;
        }
        .servicos-table tbody tr {
          border-bottom: 1px solid #f1f5f9; transition: background 0.15s;
        }
        .servicos-table tbody tr:hover { background: #f8fafc; }
        .servicos-table tbody td {
          padding: 12px 16px; font-size: calc(13px * var(--font-scale)) color: #374151;
          vertical-align: middle; font-family: 'Inter', 'Segoe UI', sans-serif;
        }
        .modal-tab-btn {
          padding: 10px 16px; border: none; background: none;
          font-size: calc(13px * var(--font-scale)) font-weight: 500; color: #6b7280;
          border-bottom: 2px solid transparent; cursor: pointer;
          transition: all 0.15s; white-space: nowrap;
          font-family: 'Inter', 'Segoe UI', sans-serif;
        }
        .modal-tab-btn:hover { color: #374151; }
        .modal-tab-btn.active {
          color: #3b82f6; border-bottom-color: #3b82f6; font-weight: 600;
        }
        .material-check-row {
          padding: 10px 12px; border-radius: 8px;
          border: 1px solid #e5e7eb; background: #fff;
          margin-bottom: 8px; transition: border-color 0.15s;
        }
        .material-check-row:hover { border-color: #bfdbfe; }
        .material-check-row.selected {
          border-color: #3b82f6; background: #eff6ff;
        }
        .toggle-switch {
          position: relative; display: inline-block;
          width: 36px; height: 20px; cursor: pointer; flex-shrink: 0;
        }
        .toggle-switch input { opacity: 0; width: 0; height: 0; }
        .toggle-slider {
          position: absolute; inset: 0; border-radius: 999px;
          transition: background 0.2s;
        }
        .toggle-slider::before {
          content: ''; position: absolute;
          width: 14px; height: 14px; border-radius: 50%;
          background: #fff; top: 3px; left: 3px;
          transition: transform 0.2s;
          box-shadow: 0 1px 3px rgba(0,0,0,0.2);
        }
        input:checked + .toggle-slider { background: #3b82f6; }
        input:not(:checked) + .toggle-slider { background: #d1d5db; }
        input:checked + .toggle-slider::before { transform: translateX(16px); }
      `}</style>

      {/* ══════════════════════════════════════════════════════
          MODAL: CRIAR / EDITAR SERVIÇO
      ══════════════════════════════════════════════════════ */}
      <Modal show={showModal} onHide={handleCloseModal} centered size="lg">

        {/* Header com gradiente */}
        <Modal.Header style={{ padding: '0', border: 'none' }}>
          <div style={{
            width: '100%', padding: '20px 24px',
            background: 'linear-gradient(135deg, #1e3a5f, #2563eb)',
            display: 'flex', alignItems: 'center', gap: '12px',
          }}>
            <div style={{
              width: '40px', height: '40px', borderRadius: '10px',
              backgroundColor: 'rgba(255,255,255,0.2)',
              display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
            }}>
              <svg width="20" height="20" fill="none" stroke="white" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                  d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
              </svg>
            </div>
            <div style={{ fontSize: `calc(15px * var(--font-scale))`, fontWeight: '700', color: '#fff', flex: 1 }}>
              {currentServico ? 'Editar Serviço' : 'Criar Novo Serviço'}
            </div>
            {/* Botão fechar customizado */}
            <button
              onClick={handleCloseModal}
              style={{
                width: '28px', height: '28px', borderRadius: '6px',
                border: '1px solid rgba(255,255,255,0.3)',
                backgroundColor: 'rgba(255,255,255,0.15)',
                color: '#fff', cursor: 'pointer',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: '18px', lineHeight: 1, flexShrink: 0,
                transition: 'background 0.15s',
              }}
              onMouseEnter={e => e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.25)'}
              onMouseLeave={e => e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.15)'}
            >
              ×
            </button>
          </div>
        </Modal.Header>

        {/* Abas internas do modal */}
        <div style={{
          borderBottom: '1px solid #e5e7eb', backgroundColor: '#fff',
          display: 'flex', padding: '0 20px',
        }}>
          {[
            { key: 'dadosBasicos',   label: 'Dados do Serviço' },
            { key: 'materiais',      label: 'Materiais' },
          ].map(tab => (
            <button
              key={tab.key}
              className={`modal-tab-btn ${activeModalTab === tab.key ? 'active' : ''}`}
              onClick={() => setActiveModalTab(tab.key)}
            >
              {tab.label}
            </button>
          ))}
        </div>

        <Modal.Body style={{ padding: '0', backgroundColor: '#f9fafb' }}>
          <div style={{ padding: '20px', maxHeight: '62vh', overflowY: 'auto' }}>

            {/* ── ABA: DADOS DO SERVIÇO ── */}
            {activeModalTab === 'dadosBasicos' && (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>

                {/* Nome */}
                <div>
                  <label style={labelStyle}>Nome *</label>
                  <input
                    type="text" name="nome" value={formData.nome}
                    onChange={handleChange} required
                    placeholder="Nome do serviço"
                    style={fieldStyle}
                    onFocus={handleFieldFocus} onBlur={handleFieldBlur}
                  />
                </div>

                {/* Descrição */}
                <div>
                  <label style={labelStyle}>Descrição</label>
                  <input
                    type="text" name="descricao" value={formData.descricao}
                    onChange={handleChange}
                    placeholder="Descrição breve do serviço"
                    style={fieldStyle}
                    onFocus={handleFieldFocus} onBlur={handleFieldBlur}
                  />
                </div>

                {/* Valor + Comissão (grid) */}
                <div>
                  <label style={labelStyle}>Especialidades responsáveis *</label>
                  <label style={{
                    display: 'flex', alignItems: 'center', gap: '8px',
                    marginBottom: '8px', color: '#374151', cursor: 'pointer',
                    fontSize: `calc(13px * var(--font-scale))`,
                  }}>
                    <input
                      type={'checkbox'}
                      checked={todasEspecialidadesSelecionadas}
                      disabled={(especialidades || []).length === 0}
                      onChange={event => handleSelectAllEspecialidades(event.target.checked)}
                    />
                    Todas as especialidades do Corpo Clínico
                  </label>
                  <select
                    multiple
                    name={'especialidades'}
                    value={formData.especialidades || []}
                    onChange={handleChange}
                    required
                    style={{ ...fieldStyle, minHeight: '100px', padding: '8px' }}
                    onFocus={handleFieldFocus}
                    onBlur={handleFieldBlur}
                  >
                    {(especialidades || []).map(especialidade => (
                      <option key={especialidade.id} value={especialidade.id}>
                        {especialidade.nome}
                      </option>
                    ))}
                  </select>
                  <p style={{ fontSize: `calc(11px * var(--font-scale))`, color: '#9ca3af', marginTop: '4px', marginBottom: 0 }}>
                    Somente especialidades do Corpo Clínico com profissionais vinculados são exibidas.
                  </p>
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                  <div>
                    <label style={labelStyle}>Valor (R$) *</label>
                    <input
                      type="number" step="0.01" name="valor" value={formData.valor}
                      onChange={handleChange} required placeholder="0,00"
                      style={fieldStyle}
                      onFocus={handleFieldFocus} onBlur={handleFieldBlur}
                    />
                  </div>
                  <div>
                    <label style={labelStyle}>Comissão (%)</label>
                    <input
                      type="number" step="0.01" name="percentual_comissao"
                      value={formData.percentual_comissao || ''}
                      onChange={handleChange} placeholder="0,00"
                      style={fieldStyle}
                      onFocus={handleFieldFocus} onBlur={handleFieldBlur}
                    />
                  </div>
                </div>

                {/* Sessões */}
                <div>
                  <label style={labelStyle}>Número de Sessões *</label>
                  <input
                    type="number" step="1" min="1" name="numero_sessoes"
                    value={formData.numero_sessoes || 1}
                    onChange={handleChange} required
                    style={fieldStyle}
                    onFocus={handleFieldFocus} onBlur={handleFieldBlur}
                  />
                  <p style={{ fontSize: `calc(11px * var(--font-scale))`, color: '#9ca3af', marginTop: '4px', marginBottom: 0 }}>
                    Para pacotes, insira o total de sessões. Para serviços únicos, deixe como 1.
                  </p>
                </div>

                <label style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <input
                    type={'checkbox'}
                    name={'disponivel_agendamento_online'}
                    checked={Boolean(formData.disponivel_agendamento_online)}
                    onChange={handleChange}
                  />
                  <span>Disponível para agendamento online</span>
                </label>

                {/* Custo Material (calculado) */}
                <div>
                  <label style={labelStyle}>Custo de Material (calculado)</label>
                  <div style={{
                    padding: '9px 12px', borderRadius: '8px',
                    border: '1px solid #e5e7eb', backgroundColor: '#f9fafb',
                    fontSize: `calc(13px * var(--font-scale))`, color: '#374151',
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                  }}>
                    <span style={{ color: '#9ca3af', fontSize: `calc(12px * var(--font-scale))` }}>Calculado pelos materiais vinculados</span>
                    <span style={{ fontWeight: '700', color: '#111827' }}>
                      R$ {Number(custoMaterialCalculado || 0).toFixed(2).replace('.', ',')}
                    </span>
                  </div>
                </div>
              </div>
            )}

            {/* ── ABA: MATERIAIS ── */}
            {activeModalTab === 'materiais' && (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>

                {/* Seletor de Tipos de Materiais */}
                <div>
                  <label style={labelStyle}>Filtrar por Tipo de Material</label>
                  {isLoadingMaterialData ? (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '12px', color: '#6b7280', fontSize: `calc(13px * var(--font-scale))` }}>
                      <Spinner animation="border" size="sm" variant="primary" />
                      Carregando tipos de materiais...
                    </div>
                  ) : (
                    <select
                      multiple
                      name="tipos_materiais"
                      value={formData.tipos_materiais}
                      onChange={handleChange}
                      style={{
                        ...fieldStyle,
                        minHeight: '100px',
                        padding: '8px',
                      }}
                      onFocus={handleFieldFocus} onBlur={handleFieldBlur}
                    >
                      {tiposMateriais.map(tipo => (
                        <option key={tipo.id} value={tipo.id}>{tipo.nome}</option>
                      ))}
                    </select>
                  )}
                  <p style={{ fontSize: `calc(11px * var(--font-scale))`, color: '#9ca3af', marginTop: '4px', marginBottom: 0 }}>
                    Segure Ctrl (ou Cmd) para selecionar múltiplos tipos.
                  </p>
                </div>

                {/* Lista de Materiais */}
                {formData.tipos_materiais?.length > 0 && (
                  <div>
                    <label style={labelStyle}>
                      Selecione os Materiais e Quantidades
                    </label>

                    {isLoadingMaterialData ? (
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '12px', color: '#6b7280', fontSize: `calc(13px * var(--font-scale))` }}>
                        <Spinner animation="border" size="sm" variant="primary" />
                        Carregando materiais...
                      </div>
                    ) : materiaisFiltrados.length === 0 ? (
                      <div style={{
                        padding: '20px', textAlign: 'center', borderRadius: '8px',
                        border: '1px dashed #e5e7eb', color: '#9ca3af', fontSize: `calc(13px * var(--font-scale))`,
                      }}>
                        Nenhum material encontrado para os tipos selecionados.
                      </div>
                    ) : (
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                        {materiaisFiltrados.map(material => {
                          const isSelected = selectedMaterialsData.some(item => item.id === material.id);
                          const selectedItem = selectedMaterialsData.find(item => item.id === material.id);
                          const estoqueTotal = material.tipo_material?.estoque?.quantidade_em_estoque || 0;
                          const unidade = material.tipo_material?.unidade_medida || 'unid.';

                          return (
                            <div
                              key={material.id}
                              className={`material-check-row ${isSelected ? 'selected' : ''}`}
                            >
                              {/* Linha do checkbox */}
                              <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                                <input
                                  type="checkbox"
                                  id={`mat-${material.id}`}
                                  checked={isSelected}
                                  onChange={(e) => handleMaterialChange(material.id, e.target.checked)}
                                  style={{ marginTop: '2px', cursor: 'pointer', accentColor: '#3b82f6', flexShrink: 0 }}
                                />
                                <label
                                  htmlFor={`mat-${material.id}`}
                                  style={{ fontSize: `calc(13px * var(--font-scale))`, color: '#374151', cursor: 'pointer', flex: 1, lineHeight: '1.4' }}
                                >
                                  <span style={{ fontWeight: '600' }}>{material.nome}</span>
                                  {material.fabricante && (
                                    <span style={{ color: '#9ca3af', marginLeft: '6px', fontSize: `calc(12px * var(--font-scale))` }}>
                                      ({material.fabricante})
                                    </span>
                                  )}
                                  <div style={{ display: 'flex', gap: '8px', marginTop: '3px', flexWrap: 'wrap' }}>
                                    <span style={{
                                      fontSize: `calc(11px * var(--font-scale))`, padding: '1px 7px', borderRadius: '999px',
                                      backgroundColor: '#f3f4f6', color: '#6b7280',
                                    }}>
                                      Lote: {material.quantidade_adquirida} {unidade}
                                    </span>
                                    <span style={{
                                      fontSize: `calc(11px * var(--font-scale))`, padding: '1px 7px', borderRadius: '999px',
                                      backgroundColor: estoqueTotal > 0 ? '#f0fdf4' : '#fef2f2',
                                      color: estoqueTotal > 0 ? '#16a34a' : '#dc2626',
                                    }}>
                                      Estoque: {estoqueTotal} {unidade}
                                    </span>
                                  </div>
                                </label>
                              </div>

                              {/* Input de quantidade (visível só se selecionado) */}
                              {isSelected && (
                                <div style={{
                                  marginTop: '10px', paddingTop: '10px',
                                  borderTop: '1px solid #bfdbfe',
                                  display: 'flex', alignItems: 'center', gap: '10px',
                                }}>
                                  <label style={{ fontSize: `calc(11px * var(--font-scale))`, fontWeight: '700', color: '#3b82f6', textTransform: 'uppercase', letterSpacing: '0.5px', whiteSpace: 'nowrap' }}>
                                    Qtd. utilizada
                                  </label>
                                  <input
                                    type="number"
                                    min="0"
                                    max={Math.min(material.quantidade_adquirida, estoqueTotal)}
                                    value={selectedItem?.quantidade_utilizada || 0}
                                    onChange={(e) => handleQuantidadeChange(material.id, parseInt(e.target.value, 10))}
                                    style={{
                                      width: '90px', padding: '6px 10px', borderRadius: '6px',
                                      border: '1px solid #bfdbfe', fontSize: `calc(13px * var(--font-scale))`,
                                      color: '#374151', fontFamily: 'inherit', outline: 'none',
                                      backgroundColor: '#fff', textAlign: 'center',
                                    }}
                                    onFocus={e => { e.target.style.borderColor = '#3b82f6'; e.target.style.boxShadow = '0 0 0 3px rgba(59,130,246,0.1)'; }}
                                    onBlur={e => { e.target.style.borderColor = '#bfdbfe'; e.target.style.boxShadow = 'none'; }}
                                  />
                                  <span style={{ fontSize: `calc(12px * var(--font-scale))`, color: '#6b7280' }}>{unidade}</span>
                                </div>
                              )}
                            </div>
                          );
                        })}
                      </div>
                    )}

                    {/* Resumo do custo */}
                    {selectedMaterialsData.length > 0 && (
                      <div style={{
                        marginTop: '12px', padding: '12px 16px', borderRadius: '8px',
                        backgroundColor: '#eff6ff', border: '1px solid #bfdbfe',
                        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                      }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                          <svg width="14" height="14" fill="none" stroke="#3b82f6" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
                          </svg>
                          <span style={{ fontSize: `calc(12px * var(--font-scale))`, fontWeight: '600', color: '#2563eb' }}>
                            {selectedMaterialsData.length} material(is) selecionado(s)
                          </span>
                        </div>
                        <span style={{ fontSize: `calc(14px * var(--font-scale))`, fontWeight: '700', color: '#1e3a5f' }}>
                          Custo total: R$ {Number(custoMaterialCalculado || 0).toFixed(2).replace('.', ',')}
                        </span>
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}
          </div>
        </Modal.Body>

        <Modal.Footer style={{ borderTop: '1px solid #e5e7eb', padding: '12px 20px', gap: '8px', backgroundColor: '#fff' }}>
          <button
            onClick={handleCloseModal}
            style={{
              padding: '8px 16px', borderRadius: '8px', border: '1px solid #e5e7eb',
              backgroundColor: '#fff', color: '#374151', cursor: 'pointer',
              fontSize: `calc(13px * var(--font-scale))`, fontWeight: '500', fontFamily: 'inherit',
            }}
            onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f9fafb'}
            onMouseLeave={e => e.currentTarget.style.backgroundColor = '#fff'}
          >
            Cancelar
          </button>
          <button
            onClick={handleSubmit}
            disabled={isLoading}
            style={{
              padding: '8px 20px', borderRadius: '8px', border: 'none',
              background: isLoading ? '#93c5fd' : 'linear-gradient(135deg, #1e3a5f, #2563eb)',
              color: '#fff', cursor: isLoading ? 'not-allowed' : 'pointer',
              fontSize: `calc(13px * var(--font-scale))`, fontWeight: '600', fontFamily: 'inherit',
              display: 'flex', alignItems: 'center', gap: '8px',
              boxShadow: isLoading ? 'none' : '0 2px 8px rgba(37,99,235,0.3)',
            }}
          >
            {isLoading && (
              <Spinner as="span" animation="border" size="sm"
                style={{ width: '14px', height: '14px', borderWidth: '2px' }} />
            )}
            {isLoading ? 'Salvando...' : currentServico ? 'Salvar Alterações' : 'Criar Serviço'}
          </button>
        </Modal.Footer>
      </Modal>

      {/* ══════════════════════════════════════════════════════
          BARRA DE AÇÕES + TABELA
      ══════════════════════════════════════════════════════ */}
      <div style={{
        backgroundColor: '#fff', borderRadius: '16px',
        border: '1px solid #e5e7eb', overflow: 'hidden',
        boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
      }}>

        {/* Toolbar */}
        <div style={{
          padding: '16px 20px', borderBottom: '1px solid #f1f5f9',
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          flexWrap: 'wrap', gap: '10px',
        }}>
          <button
            onClick={handleOpenModal}
            style={{
              padding: '8px 16px', borderRadius: '8px', border: 'none',
              background: 'linear-gradient(135deg, #1e3a5f, #2563eb)',
              color: '#fff', fontSize: `calc(13px * var(--font-scale))`, fontWeight: '600',
              cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px',
              fontFamily: 'inherit', boxShadow: '0 2px 8px rgba(37,99,235,0.3)',
              transition: 'opacity 0.15s',
            }}
            onMouseEnter={e => e.currentTarget.style.opacity = '0.9'}
            onMouseLeave={e => e.currentTarget.style.opacity = '1'}
          >
            <svg width="14" height="14" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
            </svg>
            Novo Serviço
          </button>

          {/* Switch mostrar inativos */}
          <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: `calc(13px * var(--font-scale))`, color: '#6b7280', fontFamily: 'inherit' }}>
            <label className="toggle-switch">
              <input
                type="checkbox"
                checked={mostrarInativos}
                onChange={(e) => setMostrarInativos(e.target.checked)}
              />
              <span className="toggle-slider" />
            </label>
            Mostrar inativos
          </label>
        </div>

        {/* Conteúdo */}
        <div style={{ padding: '0' }}>
          {isLoading ? (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', padding: '60px', color: '#6b7280', fontSize: `calc(13px * var(--font-scale))` }}>
              <Spinner animation="border" size="sm" variant="primary" />
              Carregando serviços...
            </div>
          ) : servicos.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '60px 24px' }}>
              <svg width="48" height="48" fill="none" stroke="#d1d5db" viewBox="0 0 24 24" style={{ display: 'block', margin: '0 auto 16px' }}>
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
              </svg>
              <p style={{ margin: 0, fontSize: `calc(14px * var(--font-scale))`, color: '#9ca3af' }}>
                Nenhum serviço {mostrarInativos ? 'inativo' : 'ativo'} encontrado.
              </p>
            </div>
          ) : (
            <div style={{ overflowX: 'auto' }}>
              <table className="servicos-table">
                <thead>
                  <tr>
                    <th>Nome</th>
                    <th className="d-none d-md-table-cell">Descrição</th>
                    <th style={{ textAlign: 'right' }}>Valor</th>
                    <th style={{ textAlign: 'center' }}>Comissão</th>
                    <th style={{ textAlign: 'center' }}>Sessões</th>
                    <th style={{ textAlign: 'right' }}>Custo Mat.</th>
                    <th>Materiais</th>
                    <th style={{ textAlign: 'center' }}>Status</th>
                    <th style={{ textAlign: 'center' }}>Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {servicos.map((servico) => (
                    <tr key={servico.id} style={{ opacity: !servico.ativo ? 0.65 : 1 }}>

                      {/* Nome */}
                      <td>
                        <div style={{ fontWeight: '600', color: '#111827' }}>{servico.nome}</div>
                      </td>

                      {/* Descrição */}
                      <td className="d-none d-md-table-cell" style={{ color: '#6b7280', maxWidth: '180px' }}>
                        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'block' }}>
                          {servico.descricao || <span style={{ color: '#d1d5db', fontStyle: 'italic' }}>—</span>}
                        </span>
                      </td>

                      {/* Valor */}
                      <td style={{ textAlign: 'right' }}>
                        <span style={{ fontWeight: '700', color: '#111827' }}>
                          R$ {parseFloat(servico.valor).toFixed(2).replace('.', ',')}
                        </span>
                      </td>

                      {/* Comissão */}
                      <td style={{ textAlign: 'center' }}>
                        {servico.percentual_comissao ? (
                          <span style={{
                            padding: '2px 8px', borderRadius: '999px', fontSize: `calc(11px * var(--font-scale))`, fontWeight: '600',
                            backgroundColor: '#f0fdf4', color: '#16a34a', border: '1px solid #bbf7d0',
                          }}>
                            {parseFloat(servico.percentual_comissao).toFixed(2)}%
                          </span>
                        ) : (
                          <span style={{ color: '#d1d5db', fontStyle: 'italic', fontSize: `calc(12px * var(--font-scale))` }}>—</span>
                        )}
                      </td>

                      {/* Sessões */}
                      <td style={{ textAlign: 'center' }}>
                        <span style={{
                          padding: '2px 8px', borderRadius: '999px', fontSize: `calc(11px * var(--font-scale))`, fontWeight: '600',
                          backgroundColor: '#eff6ff', color: '#2563eb', border: '1px solid #bfdbfe',
                        }}>
                          {servico.numero_sessoes > 1 ? `${servico.numero_sessoes} sessões` : 'Única'}
                        </span>
                      </td>

                      {/* Custo Material */}
                      <td style={{ textAlign: 'right', color: '#6b7280' }}>
                        R$ {parseFloat(servico.custo_material).toFixed(2).replace('.', ',')}
                      </td>

                      {/* Materiais */}
                      <td>
                        {servico.materiais && servico.materiais.length > 0 ? (
                          <div style={{ display: 'flex', flexDirection: 'column', gap: '3px' }}>
                            {servico.materiais.map(material => (
                              <span key={material.id} style={{
                                fontSize: `calc(11px * var(--font-scale))`, padding: '1px 7px', borderRadius: '999px',
                                backgroundColor: '#f3f4f6', color: '#6b7280',
                                display: 'inline-flex', alignItems: 'center', gap: '4px',
                                width: 'fit-content',
                              }}>
                                <span style={{ width: '5px', height: '5px', borderRadius: '50%', backgroundColor: '#9ca3af', flexShrink: 0 }} />
                                {material.nome}
                                <span style={{ color: '#9ca3af' }}>({material.pivot.quantidade_utilizada})</span>
                              </span>
                            ))}
                          </div>
                        ) : (
                          <span style={{ color: '#d1d5db', fontStyle: 'italic', fontSize: `calc(12px * var(--font-scale))` }}>Nenhum</span>
                        )}
                      </td>

                      {/* Status */}
                      <td style={{ textAlign: 'center' }}>
                        <span style={{
                          display: 'inline-flex', alignItems: 'center', gap: '5px',
                          padding: '3px 10px', borderRadius: '999px', fontSize: `calc(11px * var(--font-scale))`, fontWeight: '600',
                          backgroundColor: servico.ativo ? '#f0fdf4' : '#f3f4f6',
                          color: servico.ativo ? '#16a34a' : '#6b7280',
                          border: `1px solid ${servico.ativo ? '#bbf7d0' : '#e5e7eb'}`,
                        }}>
                          <span style={{
                            width: '6px', height: '6px', borderRadius: '50%', flexShrink: 0,
                            backgroundColor: servico.ativo ? '#22c55e' : '#9ca3af',
                          }} />
                          {servico.ativo ? 'Ativo' : 'Inativo'}
                        </span>
                      </td>

                      {/* Ações */}
                      <td style={{ textAlign: 'center' }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px' }}>
                          {/* Botão Editar */}
                          <button
                            onClick={() => handleEditClick(servico)}
                            style={{
                              padding: '5px 12px', borderRadius: '6px',
                              border: '1px solid #bfdbfe', background: '#eff6ff',
                              color: '#2563eb', fontSize: `calc(12px * var(--font-scale))`, fontWeight: '600',
                              cursor: 'pointer', fontFamily: 'inherit',
                              display: 'inline-flex', alignItems: 'center', gap: '4px',
                              transition: 'opacity 0.15s',
                            }}
                            onMouseEnter={e => e.currentTarget.style.opacity = '0.8'}
                            onMouseLeave={e => e.currentTarget.style.opacity = '1'}
                          >
                            <svg width="11" height="11" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                            </svg>
                            Editar
                          </button>

                          {/* Toggle ativo/inativo */}
                          <label className="toggle-switch" title={servico.ativo ? 'Clique para inativar' : 'Clique para ativar'}>
                            <input
                              type="checkbox"
                              checked={!!servico.ativo}
                              onChange={() => handleToggleStatus(servico.id)}
                            />
                            <span className="toggle-slider" />
                          </label>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ServicosTab;
